export const pushToQuery = (router: any, currentQuery: object, param: string, value: string, routeName?: string) => {
	if (routeName && router.currentRoute?.value?.name !== routeName) return;
	router.replace({ query: { ...currentQuery, [param]: value } });
};

export const removeFromQuery = (router: any, currentQuery: any, param: string, routeName?: string) => {
	if (routeName && router.currentRoute?.value?.name !== routeName) return;
	const query = { ...currentQuery };
	delete query[param];
	router.push({ query });
};

export const updateQueryParams = (router: any, currentQuery: any, params: any, routeName?: string) => {
	if (routeName && router.currentRoute?.value?.name !== routeName) return;
	router.replace({ query: { ...currentQuery, ...params } });
};

export const addToRouterHistory = (route: string) => {
	const routerHistory = sessionStorage.getItem("routerHistory");
	if (routerHistory) {
		const routerHistoryArray = JSON.parse(routerHistory);
		routerHistoryArray.push(route);
		if (routerHistoryArray.length > 30) {
			routerHistoryArray.shift();
		}
		sessionStorage.setItem("routerHistory", JSON.stringify(routerHistoryArray));
	} else {
		sessionStorage.setItem("routerHistory", JSON.stringify([route]));
	}
};
export const getRouterHistory = () => {
	const routerHistory = sessionStorage.getItem("routerHistory");
	if (routerHistory) {
		return JSON.parse(routerHistory);
	}
	return [];
};
